export default "__VITE_ASSET__fca54b4b__"